import { OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { IDataSource } from '../../../datasource/data-source';
import { DataSourceQuery } from '../../../datasource/data-source-query';

export class E5coreUiDatagridBase implements OnInit {

	@Input() datasource: IDataSource;
	@Input() set query(value: DataSourceQuery) {
		this.search(value);
	};
	@Input() autoSearch:boolean ;
	@Input() pagesizes: number[];

	@Output() open = new EventEmitter<any>();
	@Output() select = new EventEmitter<any>();
	@Output() link = new EventEmitter<string>();

	ngOnInit(): void {
	}

	/**
	 *  Pass the open work item event on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onOpen(data: any) {
		this.open.emit(data);
	}

	/**
	 *  Pass the select link on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onSelect(data: any) {
		this.select.emit(data);
	}

	/**
	 *  Pass the open link on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onLink(link: string) {
		this.link.emit(link);
	}

	/**
	 * Execute a search with the required search expression values.
	 * @param expression the fields and values required to perform the search.
	 */
	public search(expression: DataSourceQuery) {
	}

	/**
	 * Clear the search results.
	 */
	public reset() {
	}

	/**
	 * Refresh the search results at the current page.
	 */
	public refresh() {
	}

}